
class ClubPage {
    constructor(parent) {
      this.parent = parent;
      if (!this.parent) {
        return;
      }
      this.init();
    }
      init = () => {
          this.clickEvents();
      }
       clickEvents = () => {
          let accordianHead = qsa(".accordian-head-js",this.parent);
          let accordianBLock = qsa(".accordian-block-js",this.parent);
          if(accordianHead) {
              accordianHead.forEach(item => {
                  item.addEventListener("click",(e) => {
                      accordianBLock.forEach (ele => {
                          if(e.currentTarget.parentNode != ele) {
                              ele.classList.remove("active");
                          }
                      })
                      e.currentTarget.parentNode.classList.toggle("active");
                  })
              });
          }
          let faqHead = qsa(".faq-head-js",this.parent);
          if(faqHead) {
              faqHead.forEach(item => {
                  item.addEventListener("click",(e) => {
                      e.currentTarget.parentNode.classList.toggle("active");
                  })
              });
          }
      }
  }
  new ClubPage(qs('.club-faq-section-js'));